import Controller from "./travelRequests.controller";
import template from "./travelRequests.html";

const travelRequests = {
  template,
  controller: Controller,
};

export default travelRequests;



// WEBPACK FOOTER //
// ./src/pages/travelRequests/travelRequests.component.js